"use client"
import putCidadao from "@/app/actions/put-cidadao";
import { Button } from "@/components";
import { Modal } from "@/components/modal";
import { FormEvent, useState } from "react";
import { toast } from "sonner";

interface FollowEmailModalProps {    
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    id_gov: string;
    callback: () => void;
}

export function FollowEmailModal({isOpen, onOpenChange, id_gov, callback}: FollowEmailModalProps) {
    const [email, setEmail] = useState("")
    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!id_gov || id_gov === "") return;
        
        const response = await putCidadao({
            id_gov: id_gov,
            email: email,
        });
        if (!response) {
            toast.error("Erro ao atualizar o e-mail do cidadão.");
            return
        }
        toast.success("E-mail atualizado com sucesso.");
        callback()
        onOpenChange(false)
    }
    return (
        <Modal isOpen={isOpen} onOpenChange={onOpenChange} title={"Acompanhar"}>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                Para acompanhar este problema, deixe o seu e-mail:
                <input className="w-full p-4 border border-gray-300 rounded-4xl pr-9" placeholder="E-mail" type="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)}/>
                <div className="flex flex-row items-end justify-end gap-2">
                    <Button variant="default" type="submit">
                        Enviar
                    </Button>
                    <Button variant="outlined-primary" type="button" onClick={() => onOpenChange(false)}>
                        Cancelar
                    </Button>
                </div>
            </form>
        </Modal>
    )
}